import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import { useDeleteWorkspace } from 'hooks/useDeleteWorkspace'; // replace with your actual hooks path
import { useAuthContext } from 'hooks/useAuthContext';

export const WorkspaceDeleteComponent = (props: { onClose: () => void; onActionSuccess: () => void; open: boolean }) => {
    const { t } = useTranslation();
    const { deleteWorkspace, deletingWorkspace } = useDeleteWorkspace();
    const { userState } = useAuthContext();

    const handleDeleteWorkspace = useCallback(async () => {
        const resp = await deleteWorkspace({ workspaceId: userState.user.selectedWorkspace.workspaceId});
        if (resp?.success) {
            props.onActionSuccess();
            props.onClose();
        }
    }, [userState.user.selectedWorkspace.workspaceId, deleteWorkspace, props]);

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>{t('admin.deleteWorkspace')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('admin.deleteWorkspaceWarning')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>{t('admin.cancel')}</Button>
                <LoadingButton loading={deletingWorkspace} onClick={handleDeleteWorkspace}>{t('admin.delete')}</LoadingButton>
            </DialogActions>
        </Dialog>
    );
};